import { css } from 'emotion';
import { animationTransition, colors } from '@joykit/variables';
import chroma from 'chroma-js';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { space } from '@joykit';

export namespace styles {
  export const container = css({
    minHeight: '100%',
    fontFamily: 'Inter UI',
    padding: '16px 40px',
    maxWidth: 1680,
    margin: '0 auto',
    '@media(min-width: 678px)': {
      padding: '64px 40px'
    }
  });

  export const filterOptionsContainer = css({
    display: 'flex'
  });

  export const exhibitsContainer = css({});
  export const column = css({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  });

  export const getStartedContainer = css({
    width: 750,
    maxWidth: '100%',
    margin: '0 auto',
    marginTop: '64px',
    textAlign: 'center',
    ' span': {
      ...getInterUIDynamicMetricCssObject(16),
      marginBottom: '16px',
      display: 'inline-block',
      fontSize: '30',
      fontFamily: 'PT serif'
    },
    ' p': {
      ...getInterUIDynamicMetricCssObject(15),
      fontSize: 17,
      margin: space.stack.lg
    }
  });

  export const getStarted = () => {
    const backgroundColor = chroma(colors.purple_90)
      .alpha(0.8)
      .css();
    const darkenedBackground = chroma(backgroundColor)
      .darken(0.2)
      .css();
    return css({
      display: 'inline-block',
      color: 'white',
      padding: '16px 64px',
      textDecoration: 'none',
      borderRadius: '5px',
      transition: animationTransition('border-color', 'background-color'),
      backgroundColor,
      ':hover': {
        backgroundColor: darkenedBackground,
        borderColor: darkenedBackground
      }
    });
  };
}
